import { Component, AfterContentChecked, Output, EventEmitter } from '@angular/core';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { SetFocus } from '../../app/shared/setFocus';
import { PartSupplierPruService } from '../partsupplierpru/partsupplierpru.service';
import { PartListBE } from '../partsupplierpru/shared/partsupplierpru.model';
import { PArray } from '../shared/packit-array';

@Component({
    moduleId: module.id,
    selector: 'multi-part-search',
    templateUrl: 'multi-part-search.html',
    providers: [PartSupplierPruService],
})
export class MultiPartSearchComponent implements AfterContentChecked {
    searchKeyStrokeDelay = 350;
    searchListDelayTimerDelay = 250;
    showPartSearchSpinner = false;
    PartSearchListDelayTimer: any = null;
    searchPartText = '';
    searchInDescription = false;
    viewPartList = false;
    typeDelayTimer: any = null;
    selectedPart: PartListBE = null;
    searchPartsList: PartListBE[] = null;
    //partSearchResult: Array<PartListBE> = [];
    selectedSearchPart: PartListBE = null;
    setFocus: SetFocus = new SetFocus();
    isFocusSet = false;

    @Output() partSelectedExecuteCommand: EventEmitter<Array<PartListBE>> = new EventEmitter<PartListBE[]>();
    partSearchResult: PArray<PartListBE> = new PArray(new Array<PartListBE>());
    selectedPartsPArr: PArray<PartListBE> = new PArray(new Array<PartListBE>());

    constructor(
        private partSupplierPruService: PartSupplierPruService,
        private errHandler: ErrorHandlerService
    ) { }

    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to('searchPartInput', this.isFocusSet);
    }


    // ----------------------------------------------------------
    // Fetch list data
    // ----------------------------------------------------------
    searchParts() {
        this.errHandler.emitErrorObject(null);
        this.partSearchResult = null;
        this.showPartSearchSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.partSupplierPruService.searchPart(this.searchPartText, this.searchInDescription)
            .subscribe(returnObject => this.searchPartResponse(returnObject));
    }

    searchPartResponse(returnObject: IReturnObject) {
        this.partSearchResult = new PArray(new Array<PartListBE>());
        this.selectedPartsPArr = new PArray(new Array<PartListBE>());
        console.log(returnObject.DataList);

        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'MaterialSearchComponent.gsearchMaterialResult', returnObject.ErrorType);
        else
            this.partSearchResult = new PArray(returnObject.DataList);

        this.showPartSearchSpinner = false;
        // if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
        //     this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.searchPartResponse', returnObject.ErrorType);
        // } else {
        //     this.partSearchResult = returnObject.DataList;
        // }
        // this.showPartSearchSpinner = false;
    }


    // ----------------------------------------------------------
    // Search  part
    // ----------------------------------------------------------
    searchPartTextChanged() {
        //  var that = this; // needed to preserve scope reference to this within setinterval function

        // if (that.searchPartText.length >= 2) {
        //     that.viewPartList = true;

        //     // If this.typeDelayTimer is not nulll then the  
        //     // user typed somthing new within time limit so reset timer
        //     if (this.typeDelayTimer != null)
        //         clearInterval(that.typeDelayTimer);

        //     that.typeDelayTimer = setInterval(function () {
        //         that.searchParts();
        //     }, this.searchKeyStrokeDelay);
        // }
        // else {
        //     that.viewPartList = false;
        //     this.partSearchResult = new PArray(new Array<PartListBE>());
        //     clearInterval(this.typeDelayTimer);
        // }
        var that = this; // needed to preserve scope reference to this within setinterval function

      if (this.searchPartText.length >= 2) {

          // If this.typeDelayTimer is not nulll then the
          // user typed somthing new within time limit so reset timer
          if (this.typeDelayTimer != null)
              clearInterval(this.typeDelayTimer);

          this.typeDelayTimer = setInterval(function () {
              that.searchParts();
          }, this.searchKeyStrokeDelay);
      }
      else {
          this.partSearchResult = new PArray(new Array<PartListBE>());
          clearInterval(this.typeDelayTimer);
      }
    }

    startPartSearchListWithDelay() {
        const that = this;

        if (!that.viewPartList) {
            clearInterval(this.PartSearchListDelayTimer);
            return;
        }

        if (that.PartSearchListDelayTimer != null) {
            clearInterval(that.PartSearchListDelayTimer);
        }

        that.PartSearchListDelayTimer = setInterval(function () {
            that.finalizeHidePartSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    finalizeHidePartSearchListWithDelay() {
        this.viewPartList = false;
        clearInterval(this.PartSearchListDelayTimer);
    }

    hidePartSearchListWithDelay() {
        clearInterval(this.PartSearchListDelayTimer);
        this.startPartSearchListWithDelay();
    }

    showPartSearchList() {
        if (this.searchPartText.length >= 2) {
            clearInterval(this.PartSearchListDelayTimer);
            this.viewPartList = true;
        }
    }

    setSearchSelectedPart(part: PartListBE): void {
        //this.selectedSearchPart = part;
            let inx = this.selectedPartsPArr.indexOf(part);
            if (inx == -1)
                this.selectedPartsPArr.push(part);
            else
                this.selectedPartsPArr.removAtIndex(inx);
    }

    onPressOk() {
        console.log("multi - Part.html"+this.selectedPartsPArr.Array());
        this.partSelectedExecuteCommand.emit(this.selectedPartsPArr.Array());
    }

    isPartInSearchListChecked(partId: number): boolean {
        // return this.selectedSearchPart !== null
        //     && this.selectedSearchPart.Id === partId;
         let inx = this.selectedPartsPArr.getIndexByProperty("Id", partId);
        return inx != null;
    }

    isSearchPartSelected(): boolean {
        //return this.selectedSearchPart !== null;
        return this.selectedPartsPArr.Array().length == 0;
    }

    closeDlg() {
        this.partSelectedExecuteCommand.emit(null);
    }

    onSingleAddPart(event) {
        if (event.key === "Enter" && this.searchResult().length >= 2) {
            this.partSelectedExecuteCommand.emit(this.searchResult());
        }
    }

    searchResult() {
        if (this.partSearchResult != null && this.searchPartText.length >= 2)
            return this.partSearchResult.Array();
        else
            return [];
    }

    onSelectedAddPart(event) {
        if (this.isSearchPartSelected && event.key === "Enter") {
            this.onPressOk();
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/part-search/multi-part-search.component.ts